<template>
  <div>
    <div v-if="$vuetify.breakpoint.mdAndUp" class="mb-5">
      <v-row class="mb-1" align="center">
        <v-divider class="mr-5 "></v-divider>
        <h2 class="text-h2 liiblack--text mb-0">{{name}}</h2> 
        <v-divider class="ml-5"></v-divider>
      </v-row>
      <p class="text-caption text-center" >{{amount}}</p>
    </div>
    <v-row class="mb-5" v-else>
      <v-col>
        <v-divider></v-divider>
        <h2 class="text-h2 liiblack--text text-center my-1 ">{{name}}</h2> 
        <p class="text-caption footergrey--text text--darken-2 text-center mb-1" >{{amount}}</p>
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name:'SponsorTier',
    props:{           
      name: String,
      amount: String,
    },
  }
</script>
